import React from 'react';

export default function RefreshSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1157 4.91058L12.1157 4.91068L12.7206 4.92506L12.7807 5.00497C12.7808 5.00494 12.7808 5.00491 12.7808 5.00487C12.9903 4.84723 13.0328 4.54966 12.8751 4.33993C11.7107 2.78987 9.93368 1.9 8.00008 1.9C4.63627 1.9 1.9 4.63627 1.9 8.00008C1.9 8.26231 2.11277 8.47508 2.375 8.47508C2.63724 8.47508 2.85001 8.26231 2.85001 8.00008C2.85001 5.16028 5.16028 2.85001 8.00008 2.85001C9.63249 2.85001 11.132 3.60059 12.1157 4.91058Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M3.21949 10.9955L3.21934 10.9956C3.0098 11.1532 2.96722 11.4509 3.12497 11.6606C4.28931 13.2107 6.06637 14.1006 7.99998 14.1006C11.3638 14.1006 14.1001 11.3643 14.1001 8.00051C14.1001 7.73844 13.8875 7.52505 13.6251 7.52505C13.3628 7.52505 13.1501 7.73782 13.1501 8.00005C13.1501 10.8398 10.8398 13.1501 7.99998 13.1501C6.36756 13.1501 4.86808 12.3994 3.88437 11.09L3.88434 11.0899C3.72656 10.8802 3.42892 10.8386 3.21949 10.9955Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M10.3749 5.10004H12.625C12.8872 5.10004 13.1 4.88727 13.1 4.62503V2.375C13.1 2.11277 12.8872 1.9 12.625 1.9C12.3627 1.9 12.15 2.11277 12.15 2.375V4.15003H10.3749C10.1127 4.15003 9.89994 4.3628 9.89994 4.62503C9.89994 4.88727 10.1127 5.10004 10.3749 5.10004Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M2.89994 13.6251C2.89994 13.8873 3.11271 14.1001 3.37494 14.1001C3.63718 14.1001 3.84995 13.8873 3.84995 13.6251V11.8501H5.62497C5.8872 11.8501 6.09998 11.6373 6.09998 11.3751C6.09998 11.1128 5.8872 10.9001 5.62497 10.9001H3.37494C3.11271 10.9001 2.89994 11.1128 2.89994 11.3751V13.6251Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </svg>
  );
}
